export default __webpack_public_path__ + "static/media/information--end-of-advisory-maximum-speed-limit-40--g1.d09cf637.png";